// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3zRpL","search":"Settings_search__3SpHa","filter":"Settings_filter__1gxoV"};